import { i18n } from '@lt/localization';

export const getActiveLabelForCancellationPolicy = (
  isHotelOnly: boolean,
): string =>
  i18n.t('filters.cancellation.free', {
    context: isHotelOnly ? 'hotel' : 'package',
  });
